module.exports = __webpack_public_path__ + "static/media/yieldify_icon.ff87df94.png";